/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AbstractStoreConf } from './abstractStoreConf';
import { ConvertTypeTransformConf } from './convertTypeTransformConf';
import { CsvProcessingLoadConf } from './csvProcessingLoadConf';
import { FileProcessingLoadConf } from './fileProcessingLoadConf';
import { FtpExtractConf } from './ftpExtractConf';
import { ImportFile } from './importFile';
import { JoinExtractConf } from './joinExtractConf';
import { ReplaceHeaderTransformConf } from './replaceHeaderTransformConf';
import { SaveQueryExtractConf } from './saveQueryExtractConf';
import { ScriptProcessingLoadConf } from './scriptProcessingLoadConf';
import { SharedFileExtractConf } from './sharedFileExtractConf';
import { SqlProcessingLoadConf } from './sqlProcessingLoadConf';
import { SqlRequestExtractConf } from './sqlRequestExtractConf';
import { StringTransformConf } from './stringTransformConf';
import { TranslatorTransformConf } from './translatorTransformConf';

export interface EtlConf {
    id?: string; 
    typeProcess?: string;
    name?: string;
    code?: string;
    description?: string;
    complet?: boolean;
    extract?: FtpExtractConf | JoinExtractConf | SaveQueryExtractConf | SharedFileExtractConf | SqlRequestExtractConf;
    transforms?: Array<ConvertTypeTransformConf | ReplaceHeaderTransformConf | StringTransformConf | TranslatorTransformConf>;
    processingLoad?: CsvProcessingLoadConf | FileProcessingLoadConf | ScriptProcessingLoadConf | SqlProcessingLoadConf;
    notifications?: Array<AbstractStoreConf>;
    typeJob?: EtlConf.TypeJobEnum;
    scheduleJob?: EtlConf.ScheduleJobEnum;
    schedulers?: string;
    partner?: string;
    exportPartners?: Array<string>;
    exportMode?: EtlConf.ExportModeEnum;
    exportAffiliatesColumn?: boolean;
    personalDataAccessPartners?: Array<string>;
    affectedPartners?: Array<string>;
    owner?: string;
    file?: ImportFile;
    provider?: string;
    type?: string;
}
export namespace EtlConf {
    export type ExportModeEnum = 'GROUPED' | 'SEPARATE';
    export const ExportModeEnum = {
        GROUPED: 'GROUPED' as ExportModeEnum,
        SEPARATE: 'SEPARATE' as ExportModeEnum
    };
    export type TypeJobEnum = 'IMPORT' | 'EXPORT';
    export const TypeJobEnum = {
        IMPORT: 'IMPORT' as TypeJobEnum,
        EXPORT: 'EXPORT' as TypeJobEnum
    };
    export type ScheduleJobEnum = 'DAILY' | 'MONTHLY' | 'NONE';
    export const ScheduleJobEnum = {
        DAILY: 'DAILY' as ScheduleJobEnum,
        MONTHLY: 'MONTHLY' as ScheduleJobEnum,
        NONE: 'NONE' as ScheduleJobEnum
    };
}